// Animationen aus (Einstellung im Kopf von Version 3), wirkt sofort und ohne Neuladen.
// - Alle Grafiken fragen „Bewegung reduzieren“ über useReducedMotion aus src/version/reducedMotion.js ab,
//   das berücksichtigt diese Einstellung zusätzlich zur Systemeinstellung und reagiert live.
// - framer-motion Übergänge folgen über MotionConfig in App.js.
// - Eigene Abfragen von window.matchMedia("(prefers-reduced-motion: reduce)") liefern ebenfalls „reduzieren“.
// - CSS Animationen und Übergänge schaltet die Klasse rl-motion-off am html ab.
// Die Wahl steht im Browser Speicher und, falls der gesperrt ist, in der Adresse (?motion=off).
import { useSyncExternalStore } from "react";

const KEY = "parto-motion-off";
const params = () => { try { return new URLSearchParams(window.location.search); } catch { return new URLSearchParams(); } };

let off = (() => {
    const q = params().get("motion");
    if (q === "off") return true;
    if (q === "on") return false;
    try { return window.localStorage.getItem(KEY) === "1"; } catch { return false; }
})();
const listeners = new Set();

const apply = () => { document.documentElement.classList.toggle("rl-motion-off", off); };

// Eigene matchMedia Abfragen: bei „Animationen aus“ immer „reduzieren“ melden
if (typeof window !== "undefined" && window.matchMedia) {
    const original = window.matchMedia.bind(window);
    window.matchMedia = (query) => {
        const mq = original(query);
        if (off && /prefers-reduced-motion\s*:\s*reduce/.test(query)) {
            return { matches: true, media: query, onchange: null, addListener: () => {}, removeListener: () => {}, addEventListener: () => {}, removeEventListener: () => {}, dispatchEvent: () => false, __proto__: mq };
        }
        return mq;
    };
    apply();
}

export const getMotionOff = () => off;

export const setMotionOff = (next) => {
    off = !!next;
    apply();
    try { window.localStorage.setItem(KEY, off ? "1" : "0"); } catch { /* ohne Speicher gilt die Adresse */ }
    try {
        const p = params();
        p.set("motion", off ? "off" : "on");
        window.history.replaceState(window.history.state, "", `${window.location.pathname}?${p.toString()}${window.location.hash}`);
    } catch { /* Adresse lässt sich nicht ändern, Einstellung gilt bis zum Neuladen */ }
    listeners.forEach((l) => l());
};

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
export const useMotionOff = () => useSyncExternalStore(subscribe, getMotionOff, getMotionOff);
